<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center" v-if="ptac.ptac_nr===0">Create an action for lead {{ ptac.pten_code }}</v-card-title>
            <v-card-title class="justify-center" v-else>Update action {{ ptac.ptac_nr }} of lead {{ ptac.pten_code }}</v-card-title>
            <v-divider></v-divider>
            <v-row no-gutters class="ma-4 mb-0" v-if="!setComplete">
                <v-col cols="6" class="pr-4">
                    <v-select v-model="ptac.patp_code" :disabled="ptac.ptac_nr!==0" :clearable="true" :items="ptac.patp_codeKeuzes" item-value="patp_code" item-text="patp_oms" label="Type of action" v-on:change="changeType" dense></v-select>
                </v-col>  
                <v-col cols="6" v-if="!isFolderAction">
                    <date_picker label="Complete action before" :date="ptac.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData" dense/> 
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-4 mb-4" v-if="!isFolderAction&&!setComplete">
                <v-col cols="12" >
                    <v-textarea v-model="ptac.ptac_oms" rows="4" label="Action description" v-bind:rules="descriptionRules" dense></v-textarea>
                </v-col>
            </v-row>
            <v-row class="mx-4 my-4" no-gutters v-if="ptac.ptac_nr > 0&&!setComplete">
                <v-col cols="12">
                    <v-textarea v-model="ptac.ptac_result" rows="4" label="Action result" dense></v-textarea>
                </v-col>
            </v-row>
            <!-- Moet agent zijn, om op datum te kunnen sorteren.
            <v-row no-gutters>
                <v-col cols="5" class="mx-5 mt-4">
                    <v-select v-model="ptac.gebr_code" :clearable="true" :items="ptac.gebr_codeKeuzes" item-value="gebr_code" item-text="gebr_naam" label="Action for"  dense></v-select>
                </v-col>  
            </v-row> 
            -->
            <v-divider v-if="isFolderAction"></v-divider>
            <v-card-title class="justify-center" v-if="isFolderAction">Follow up action</v-card-title>
            <v-divider v-if="isFolderAction"></v-divider>
            <v-row no-gutters class="ma-4 mb-0" v-if="isFolderAction">
                <v-col cols="6" class="pr-4">
                    <v-select v-model="followUp.patp_code" :clearable="true" :items="codeKeuzes" item-value="patp_code" item-text="patp_oms" label="Type of follow up action" dense></v-select>
                </v-col>  
                <v-col cols="6">
                    <date_picker label="Follow up complete before" :date="followUp.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData2" dense/> 
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-4 mb-4" v-if="isFolderAction">
                <v-col cols="12">
                    <v-textarea v-model="followUp.ptac_oms" rows="4" label="Follow up description" v-bind:rules="descriptionRules" dense></v-textarea>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-4 mb-4" v-if="ptac.ptac_nr!==0&&!setComplete">
                <v-col cols=4></v-col>
                <v-col cols=4>
                    <v-select v-model="ptac.pten_stat" :items="codeKeuzesChangeLead" item-value="ptst_code" item-text="ptst_oms" label="Set new lead status" dense></v-select>
                </v-col>
                <v-col cols=4></v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row no-gutters class="mx-4 mb-4" v-if="ptac.ptac_nr!==0">
                <v-col cols="6">
                    <v-checkbox v-model="setComplete" :disabled="ptac.ptac_result===''" >
                        <template v-slot:label> 
                            Set Action done <b v-if="ptac.ptac_result===''">&nbsp;(Action result must be given)</b>
                        </template>
                    </v-checkbox>
                </v-col>
                <v-col cols="6" v-if="setComplete">
                    <v-checkbox v-model="setLeadClosed" label="Set lead closed"></v-checkbox>
                </v-col>
            </v-row>
            <div v-if="setComplete&&!setLeadClosed">
                <v-divider></v-divider>
                <v-card-title class="py-0 justify-center">Follow up action</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-4">
                    <v-col cols="12">
                        <v-checkbox v-model="followUp.addFollowUp" :disabled="followUp.followUpRequired" label="Add follow up"></v-checkbox>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-4">
                    <v-col cols="6" class="pr-4">
                        <v-select v-model="followUp.patp_code" :clearable="true" :items="codeKeuzes" item-value="patp_code" item-text="patp_oms" label="Type of action" v-on:change="setFollowUp" dense></v-select>
                    </v-col>  
                    <v-col cols="6">
                        <date_picker label="Complete follow up action before" :date="followUp.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData" dense v-if="this.followUpType!=='close'"/>
                        <v-select v-model="followUp.pten_stat" :clearable="true" :items="codeKeuzesClosed" item-value="ptst_code" item-text="ptst_oms" label="Reason of close" dense v-if="this.followUpType==='close'"></v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-4">
                    <v-col cols="12">
                        <v-textarea v-model="followUp.ptac_oms" rows="3" :label="this.followUpType!=='close'?'Follow up description':'Closed description (for all open actions)'" v-bind:rules="descriptionRules" dense></v-textarea>
                    </v-col>
                </v-row>            
                <v-row no-gutters class="mx-4">
                    <v-col cols="12" class="mt-2">
                        <v-textarea v-model="followUp.pten_close" rows="3" label="Optional: Note to add to lead" dense v-if="this.followUpType==='close'"></v-textarea>
                    </v-col>
                </v-row>                 
                <v-divider v-if="this.followUpType!=='close'"></v-divider>
                <v-card-title class="py-0 justify-center" v-if="this.followUpType!=='close'">New lead status</v-card-title>
                <v-divider v-if="this.followUpType!=='close'"></v-divider>
                <v-row no-gutters class="pt-4 px-4" v-if="this.followUpType!=='close'">
                    <v-col cols=4></v-col>
                    <v-col cols=4>
                        <v-select v-model="followUp.pten_stat" :items="codeKeuzesChange" item-value="ptst_code" item-text="ptst_oms" label="Set new lead status" dense></v-select>
                    </v-col>
                    <v-col cols=4></v-col>
                </v-row>
            </div>
            <div v-if="setComplete&&setLeadClosed">
                <v-divider></v-divider>
                <v-card-title class="py-0 justify-center">Close lead</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="ma-4">
                    <v-col cols="6">
                        <v-select v-model="followUp.pten_stat" :clearable="true" :items="codeKeuzesClosed" item-value="ptst_code" item-text="ptst_oms" label="Reason of close" dense></v-select>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="ma-4">
                    <v-col cols="12">
                        <v-textarea v-model="followUp.ptac_oms_closed" rows="3" :label="'Closed description (for all open actions)'" v-bind:rules="descriptionRules" dense></v-textarea>
                    </v-col>
                </v-row>            
                <v-row no-gutters class="mx-4">
                    <v-col cols="12" class="mt-2">
                        <v-textarea v-model="followUp.pten_close" rows="3" label="Optional: Note to add to lead" dense></v-textarea>
                    </v-col>
                </v-row>                 
            </div>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="addAction" v-if="!setComplete">Save & Close</v-btn>
                <v-btn color="primary" small @click="closeLead" v-if="setComplete&&setLeadClosed">Close lead</v-btn>
                <v-btn color="primary" small @click="setActionComplete" v-if="setComplete&&!setLeadClosed">Set Action Done</v-btn>
                <v-btn color="primary" small @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import date_picker from "@/components/ui/date_picker.vue";

    export default {
        components: {
            date_picker,
        },
        computed: {
        },
        data() {
            return {
                dialog: false,
                isFolderAction: false,
                setComplete: false,
                setLeadClosed: false,
                pten_encrid: "",
                codeKeuzes: [],
                codeKeuzesChangeLead: [],
                codeKeuzesChange: [],
                codeKeuzesClosed: [],
                ptac: {
                    ptac_nr: 0,
                    ptac_result: "",
                },
                followUp: {},
                followUp00: {},
                followUp05: {},
                descriptionRules: [v => !!v || "A description / value is required"],
                followUpType: "action",
            }
        },
        methods: {
            initDialog() {
                this.dialog = false;
                this.setComplete = false;
                this.isFolderAction = false;
                this.setComplete = false;
                this.setLeadClosed = false;
                this.pten_encrid = "";
                this.codeKeuzes = [];
                this.codeKeuzesChange = [];
                this.codeKeuzesClosed = [];
                this.ptac = {
                    ptac_nr: 0,
                    ptac_result: "",
                },
                this.followUp = {};
                this.followUp00 = {};
                this.followUp05 = {};
                this.followUpType = "action";

            },
            openDialog(pten_encrid, ptac_nr) {
                this.initDialog();
                this.pten_encrid = pten_encrid;
                this.$axios.post("ares/json/ares/pten/getAction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAction",
                    },
                    getAction: {
                        pten_encrid: pten_encrid,
                        ptac_nr: ptac_nr,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.ptac = res.data.getAction;
                        this.ptac.ptac_actie_dt = this.getDate(this.ptac.ptac_actie_dt);
                        this.codeKeuzes = res.data.getAction.patp_codeKeuzes;
                        this.followUp = res.data.getAction.follow_up;
                        this.followUp.ptac_actie_dt = this.getDate(this.followUp.ptac_actie_dt);
                        this.followUp05 = res.data.getAction.follow_up_05;
                        this.followUp05.ptac_actie_dt = this.getDate(this.followUp05.ptac_actie_dt);
                        this.followUp00 = res.data.getAction.follow_up_00;
                        this.followUp00.ptac_actie_dt = this.getDate(this.followUp00.ptac_actie_dt);
                        this.changeType(this.ptac.patp_code);
                        this.codeKeuzesChangeLead = res.data.getAction.ptst_codeKeuzes_change;
                        this.codeKeuzesChange = res.data.getAction.ptst_codeKeuzes_change;
                        this.codeKeuzesClosed = res.data.getAction.ptst_codeKeuzes_closed;
                        this.dialog = true;
                    }
                });
            },
            addAction() {
                if (this.ptac.patp_code === ""||this.ptac.patp_code===null) {
                    this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: "Action type must be given",
                            color: "error",
                        });  
                        return                  
                }
                if (this.ptac.patp_code === "05-SendFolder") {
                    if (this.followUp.patp_code === ""||this.followUp.patp_code===null) {
                    this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: "A follow up action type must be given",
                            color: "error",
                        });  
                        return                  
                    }                    
                    if ((typeof this.followUp.ptac_actie_dt === 'undefined') || (this.followUp.ptac_actie_dt === null) || (this.followUp.ptac_actie_dt === "")) {
                        this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "A follow up action date must be given",
                                color: "error",
                            });  
                            return                  
                    }
                    if (this.followUp.ptac_oms === "") {
                        this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "A follow up action description must be given",
                                color: "error",
                            });  
                            return                  
                    }
                } else {
                    if ((typeof this.ptac.ptac_actie_dt === 'undefined') || (this.ptac.ptac_actie_dt === null) || (this.ptac.ptac_actie_dt === "")) {
                        this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "Action date must be given",
                                color: "error",
                            });  
                            return                  
                    }
                    if (this.ptac.ptac_oms === "") {
                        this.$store.dispatch("setSnackbar", {
                                showing: true,
                                text: "Action description must be given",
                                color: "error",
                            });  
                            return                  
                    }
                }
                this.followUp.ptac_actie_dt_ok = this.setDate(this.followUp.ptac_actie_dt);
                //console.log(this.ptac.ptac_actie_dt);
                // console.log(this.ptac);
                // console.log(this.ptac.pten_stat);
                this.$axios.post("ares/json/ares/pten/addAction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addAction",
                    },
                    addAction: {
                        pten_encrid: this.pten_encrid,
                        pten_stat: this.ptac.pten_stat,
                        ptac_nr: this.ptac.ptac_nr,
                        ptac_actie_dt_ok: this.setDate(this.ptac.ptac_actie_dt),
                        patp_code: this.ptac.patp_code,
                        ptac_oms: this.ptac.ptac_oms,
                        ptac_result: this.ptac.ptac_result,
                        follow_up: this.followUp,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        //console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.addAction.text,
                            color: res.data.addAction.color,
                        });
                        this.$emit("actionClick", "refreshActions");
                        this.closeDialog();
                    }
                });
            },
            closeLead() {
                if (!this.checkInputClosed()) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: this.message,
                        color: "error",
                    }); 
                    return                   
                }
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus",
                    },
                    setPtenStatus: {
                        pten_encrid: this.ptac.pten_encrid,
                        ptst_code: this.followUp.pten_stat,
                        actionResult: this.followUp.ptac_oms_closed,
                        ptenNote: this.followUp.pten_close,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            checkInputClosed() {
                this.message = "";
                if (this.followUp.pten_stat === "") {
                    this.message = "Missing reason of close";
                    return false;
                }
                if (this.followUp.ptac_oms_closed === "") {
                    this.message = "Missing a description for the close of all action";
                    return false;
                }
                return true;
            },
            setActionComplete() {
                if (!this.checkInput()) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: this.message,
                        color: "error",
                    }); 
                    return                   
                }
                this.$axios.post("ares/json/ares/pten/setActionComplete.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setActionComplete",
                    },
                    setActionComplete: {
                        ptac_encrid: this.ptac.ptac_encrid,
                        ptac_result: this.ptac.ptac_result,
                        follow_up: this.followUp,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setActionComplete.text,
                            color: res.data.setActionComplete.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            checkInput() {
                this.message = "";
                if (this.followUp.pten_stat === "") {
                    this.message = "Missing new lead status";
                    return false;
                }
                if (this.followUp.followUpRequired) {
                    if (this.followUp.patp_code === "") {
                        this.message = "Missing a type for follow up action";
                        return false;
                    }
                    if (this.followUp.ptac_actie_dt === "") {
                        this.message = "Missing a completion date for the follow up action";
                        return false;
                    }
                    if (this.followUp.ptac_oms === "") {
                        this.message = "Missing a description for the follow up action";
                        return false;
                    }
                }
                this.followUp.ptac_actie_dt_ok = this.setDate(this.followUp.ptac_actie_dt);
                return true;
            },
            closeDialog() {
                this.dialog = false;
            },
            setFollowUp () {
                switch (this.followUp.patp_code) {
                    case "05-SendFolder":
                        this.followUpType = "folder";
                        this.followUp.ptac_actie_dt = this.followUp05.ptac_actie_dt;
                        this.followUp.ptac_oms = this.followUp05.ptac_oms;
                        break;
                    case "99-Close":
                        this.followUpType = "close";
                        break;
                    default:
                        this.followUpType = "action";
                        this.followUp.ptac_actie_dt = this.followUp00.ptac_actie_dt;
                        this.followUp.ptac_oms = this.followUp00.ptac_oms;
                }
            },
            getDate(value) {
                if  (value === ""||value === null) {
                    return "";
                }
                if (value.substring(4, 5) === "-"||value.substring(4, 5) === "/") {
                    return value.substring(5, 7) + "-" + value.substring(8, 10) + "-" + value.substring(0, 4); 
                }
                return value.substring(3, 5) + "-" + value.substring(0, 2) + "-" + value.substring(6, 10);
            },
            setDate(date) {
                if (date.substring(2, 3) === "-") {
                    return date.substring(3, 5) + "-" + date.substring(0, 2) + "-" + date.substring(6, 10); 
                }
                return date.substring(8, 10) + "-" + date.substring(5, 7) + "-" + date.substring(0, 4); 
            },
            updateData(data) {
                this.ptac[data.field] = data.value;
            },
            updateData2(data) {
                this.followUp[data.field] = data.value;
            },
            changeType(value) {
                this.isFolderAction = (value === "05-SendFolder"); 
                if (this.isFolderAction) {
                    this.followUp = this.followUp05; 
                } else {
                    this.followUp = this.followUp00;                     
                }            
            },
            parseDate(date) {
                if (!date) return null;

                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
        },
    };
</script>

<style scoped>
</style>